import { useAsync } from 'react-use';

import { NoteIndex } from '~/modules/songs/utils/note-index';

/** Shared, so an unresolved fetch does not hand back a new object on every render. */
const NONE: NoteIndex = {};

/**
 * Per-song note measurements, fetched the same way the popularity list is. Kept out of the song
 * index because that file is regenerated on every song sync and is already the largest thing the
 * app downloads; this one is only needed once the song list starts personalising itself.
 */
export default function useNoteIndex() {
  const { value, loading } = useAsync(
    async () => (await fetch('/songs/note-index.json')).json() as Promise<NoteIndex>,
    [],
  );

  return { noteIndex: value ?? NONE, loading };
}
